<i18n src="./resources/crm/voicemail-locales.json"></i18n>

<template>
  <div class="crm-notes-container">
    <div class="additional-info">
      <div v-once class="prop-label">{{ $t('voiceMail') }}</div>
      <audio ref="audio" controls :src="interaction.callbackRecordingFile" :dark="$vuetify.theme.dark">
        Your browser does not support the
        <code>audio</code> element
      </audio>
      <div v-once class="prop-label">{{ $t('audioTranscription') }}</div>
      <div class="prop-value">
        {{ interaction.callbackRecordingTranscription }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InteractionVoiceMail',

  components: {},

  props: {
    interaction: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
audio {
  width: 100%;
  max-width: 456px;
  margin: 12px 0;
}

audio::-webkit-media-controls-enclosure {
  background-color: #0001;
  border-radius: 4px;
}

audio[dark]::-webkit-media-controls-enclosure {
  background-color: #fff3;
  border-radius: 4px;
  filter: invert(1);
}
.additional-info {
  padding: 16px;
}
.prop-label {
  color: var(--v-primary-base);
}
.prop-value {
  opacity: 0.75;
  padding: 4px 0;
}
</style>
